module.exports = __webpack_public_path__ + "img/myposition_cf_카림 벤제마.723582eb.png";